<template>
  <div class="not-prose" v-html="data.code"></div>
</template>

<script setup lang="ts">
import type { HtmlRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<HtmlRecord>,
    default: () => {}
  }
})
</script>
